/**
 * @fileoverview gRPC-Web generated client stub for taskmanager
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: task/task.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var authz_annotations_pb = require('../authz/annotations_pb.js')
const proto = {};
proto.taskmanager = require('./task_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.taskmanager.TaskManagerClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.taskmanager.TaskManagerPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.taskmanager.ListTasksRequest,
 *   !proto.taskmanager.TaskList>}
 */
const methodDescriptor_TaskManager_ListTasks = new grpc.web.MethodDescriptor(
  '/taskmanager.TaskManager/ListTasks',
  grpc.web.MethodType.UNARY,
  proto.taskmanager.ListTasksRequest,
  proto.taskmanager.TaskList,
  /**
   * @param {!proto.taskmanager.ListTasksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.taskmanager.TaskList.deserializeBinary
);


/**
 * @param {!proto.taskmanager.ListTasksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.taskmanager.TaskList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.taskmanager.TaskList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.taskmanager.TaskManagerClient.prototype.listTasks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/taskmanager.TaskManager/ListTasks',
      request,
      metadata || {},
      methodDescriptor_TaskManager_ListTasks,
      callback);
};


/**
 * @param {!proto.taskmanager.ListTasksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.taskmanager.TaskList>}
 *     Promise that resolves to the response
 */
proto.taskmanager.TaskManagerPromiseClient.prototype.listTasks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/taskmanager.TaskManager/ListTasks',
      request,
      metadata || {},
      methodDescriptor_TaskManager_ListTasks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.taskmanager.GetTasksRequest,
 *   !proto.taskmanager.TaskList>}
 */
const methodDescriptor_TaskManager_GetTasks = new grpc.web.MethodDescriptor(
  '/taskmanager.TaskManager/GetTasks',
  grpc.web.MethodType.UNARY,
  proto.taskmanager.GetTasksRequest,
  proto.taskmanager.TaskList,
  /**
   * @param {!proto.taskmanager.GetTasksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.taskmanager.TaskList.deserializeBinary
);


/**
 * @param {!proto.taskmanager.GetTasksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.taskmanager.TaskList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.taskmanager.TaskList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.taskmanager.TaskManagerClient.prototype.getTasks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/taskmanager.TaskManager/GetTasks',
      request,
      metadata || {},
      methodDescriptor_TaskManager_GetTasks,
      callback);
};


/**
 * @param {!proto.taskmanager.GetTasksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.taskmanager.TaskList>}
 *     Promise that resolves to the response
 */
proto.taskmanager.TaskManagerPromiseClient.prototype.getTasks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/taskmanager.TaskManager/GetTasks',
      request,
      metadata || {},
      methodDescriptor_TaskManager_GetTasks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.taskmanager.TaskID,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TaskManager_Stop = new grpc.web.MethodDescriptor(
  '/taskmanager.TaskManager/Stop',
  grpc.web.MethodType.UNARY,
  proto.taskmanager.TaskID,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.taskmanager.TaskID} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.taskmanager.TaskID} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.taskmanager.TaskManagerClient.prototype.stop =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/taskmanager.TaskManager/Stop',
      request,
      metadata || {},
      methodDescriptor_TaskManager_Stop,
      callback);
};


/**
 * @param {!proto.taskmanager.TaskID} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.taskmanager.TaskManagerPromiseClient.prototype.stop =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/taskmanager.TaskManager/Stop',
      request,
      metadata || {},
      methodDescriptor_TaskManager_Stop);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.taskmanager.TaskID,
 *   !proto.taskmanager.Progress>}
 */
const methodDescriptor_TaskManager_GetProgress = new grpc.web.MethodDescriptor(
  '/taskmanager.TaskManager/GetProgress',
  grpc.web.MethodType.UNARY,
  proto.taskmanager.TaskID,
  proto.taskmanager.Progress,
  /**
   * @param {!proto.taskmanager.TaskID} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.taskmanager.Progress.deserializeBinary
);


/**
 * @param {!proto.taskmanager.TaskID} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.taskmanager.Progress)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.taskmanager.Progress>|undefined}
 *     The XHR Node Readable Stream
 */
proto.taskmanager.TaskManagerClient.prototype.getProgress =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/taskmanager.TaskManager/GetProgress',
      request,
      metadata || {},
      methodDescriptor_TaskManager_GetProgress,
      callback);
};


/**
 * @param {!proto.taskmanager.TaskID} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.taskmanager.Progress>}
 *     Promise that resolves to the response
 */
proto.taskmanager.TaskManagerPromiseClient.prototype.getProgress =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/taskmanager.TaskManager/GetProgress',
      request,
      metadata || {},
      methodDescriptor_TaskManager_GetProgress);
};


module.exports = proto.taskmanager;

